export const HANDLE_LOGIN = "handleLogin";
export const HANDLE_LOGOUT = "handleLogout";
export const HANDLE_REFRESH_TOKEN = "handleRefreshToken";
export const FETCH_USER = "fetchUser";

export const DISPLAY_MESSAGE = "displayMessage";
export const HIDE_MESSAGE = "hideMessage";

export const VERIFY_CODE = "verifyCode";
export const REGISTER_PASSWORD = "registerPassword"

export const FETCH_COLLECTION_SET = "fetchCollectionSet"
export const ORDER_COLLECTION_SET = "orderCollectionSet"
export const ORDER_ANALYSIS = "orderAnalysis";

export const CHECK_TOKEN_AFTER_RELOAD = "checkTokenAfterReload"

export const FETCH_ANALYSIS_PACKAGES = "fetchAnalysisPackages";

export const FETCH_SURVEY_ANSWERS = "fetchSurveyAnswers";
export const SAVE_SURVEY_ANSWERS = "saveSurveyAnswers";

export const FETCH_COUNTRIES = "fetchCountries";

export const FETCH_CONSULTATION_LIST = "fetchConsultationList";
export const BOOK_CONSULTATION = "selectConsultation";
export const CANCEL_CONSULTATION = "cancelConsultation";
export const FETCH_USER_ANALYSIS = "fetchUserAnalysis";

export const FETCH_SURVEYS_LIST = "fetchSurveysList";
export const FETCH_USER_SURVEY = "fetchUserSurvey";

export const SET_LOCALE_A = "setLocale";
///aaa


// WEBPACK FOOTER //
// ./src/store/actions.js